/**
 * @packageDocumentation
 * @module api.functional.auth.reset_password.request
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponsenull } from "../../../../structures/ServiceResponsenull";

/**
 * @controller AuthController.requestPasswordResetLink
 * @path POST /auth/reset-password/request/:email
 * @accessor api.functional.auth.reset_password.request.requestPasswordResetLink
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function requestPasswordResetLink(
  connection: IConnection,
  email: string,
): Promise<requestPasswordResetLink.Output> {
  return PlainFetcher.fetch(connection, {
    ...requestPasswordResetLink.METADATA,
    template: requestPasswordResetLink.METADATA.path,
    path: requestPasswordResetLink.path(email),
  });
}
export namespace requestPasswordResetLink {
  export type Output = ServiceResponsenull;

  export const METADATA = {
    method: "POST",
    path: "/auth/reset-password/request/:email",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = (email: string) =>
    `/auth/reset-password/request/${encodeURIComponent(email?.toString() ?? "null")}`;
}
